import React from "react"
import { Typography } from "@mui/material"


export default function dateColumn() {
	let id = 0
	return {
		name: 'Date from & to',
		render: (_, row) => <Typography>{`From ${row.dateFrom} to ${row.dateTo}`}</Typography>,
		setBodyCellProps: () => {
			id++
			return { sx: { backgroundColor: id % 2 === 0 || (id % 2 === 0 && id !== 0) ? "background.grey" : "background.lightGrey" } }
		}
	}
}